var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('cub-page-content',{attrs:{"content":_vm.pageContent}}),_vm._v(" "),_c('cub-news-feed',{attrs:{"posts":_vm.fbPosts}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c6fc2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/home/Home.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-30c6fc2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/home/Home.vue
// module chunks = 0